// Auto-généré depuis departementsPratiquesEnergData.js par /app/scripts/split_departement_data.js
// NE PAS ÉDITER À LA MAIN — régénère via le script.

const data = {
  "code": "75",
  "name": "Paris",
  "slug": "75-paris",
  "prefecture": "Paris",
  "prefectureSlug": "paris",
  "region": "Île-de-France",
  "postalCode": "75001",
  "geo": {
    "lat": "48.8566",
    "lng": "2.3522"
  },
  "inDept": "Paris",
  "deptArticle": "Paris (75)",
  "nameWithArticle": "Paris",
  "numPros": 124,
  "villes": [
    "Paris Centre (1er-4e)",
    "Paris Ouest (7e, 8e, 16e)",
    "Paris Est (11e, 12e, 20e)",
    "Paris Nord (9e, 17e, 18e)",
    "Boulogne-Billancourt",
    "Saint-Denis"
  ],
  "heroSubtitle": "Magnétiseurs, Reiki, Lithothérapie et soins énergétiques, au cœur de l'Île-de-France",
  "intro": "Capitale mondiale de la culture et lumière de la France, <strong>Paris</strong> est un territoire unique où l'énergie tellurique se mêle à une intense activité humaine. Du cœur historique de l'<strong>Île-de-France</strong> aux quartiers périphériques, les pratiques énergétiques trouvent ici un terrain d'expression à la mesure de la diversité parisienne. Entre les <strong>axes sacrés</strong> de la ville, les <strong>jardins historiques</strong> et la <strong>Seine</strong> serpentant à travers la métropole, ce département unique offre une énergie d'une complexité et d'une richesse remarquables. Les praticiens en magnétisme, reiki, lithothérapie et géobiologie du 75 travaillent avec les forces subtiles de cette ville millénaire, créant des oasis de bien-être au cœur de l'agitation urbaine.",
  "specialites": [
    {
      "icon": "🧲",
      "title": "Magnétisme",
      "text": "Les magnétiseurs du 75 exercent dans un cadre urbain d'exception. Spécialisés dans le stress métropolitain, les douleurs chroniques liées à la vie citadine et les déséquilibres énergétiques, ils travaillent avec des techniques adaptées au rythme intense de la capitale. Leur approche allie efficacité parisienne et profondeur du soin par les mains pour répondre aux besoins urgents des citadins."
    },
    {
      "icon": "🙏",
      "title": "Reiki",
      "text": "Le reiki trouve à Paris un public exigeant et diversifié. Les praticiens utilisent l'énergie universelle pour harmoniser corps et esprit, en réponse aux besoins spécifiques des Parisiens soumis aux sollicitations permanentes de la vie urbaine. Les séances dans les cabinets calmes des arrondissements historiques offrent des bulles de paix au cœur de l'agitation."
    },
    {
      "icon": "💎",
      "title": "Lithothérapie",
      "text": "Les lithothérapeutes du 75 travaillent avec les pierres et cristaux pour rééquilibrer les énergies. Leur approche s'appuie sur des pierres de protection contre les nuisances électromagnétiques urbaines comme la tourmaline noire et le shungite, créant des soins énergétiques parfaitement adaptés à l'environnement parisien."
    },
    {
      "icon": "💚",
      "title": "Soins Énergétiques",
      "text": "Les praticiens en soins énergétiques du 75 proposent des soins holistiques combinant magnétisme, reiki et techniques modernes. Au cœur de la métropole, ils libèrent les mémoires cellulaires et réharmonisent les chakras avec une approche urbaine et sophistiquée, caractéristique de l'excellence parisienne."
    },
    {
      "icon": "🔥",
      "title": "Coupeur de Feu",
      "text": "Héritiers d'une tradition ésotérique parisienne séculaire, les coupeurs de feu du 75 perpétuent un savoir ancestral au cœur de la capitale. Des alchimistes du Moyen Âge aux guérisseurs contemporains, Paris a toujours abrité ces dons rares qui continuent de fasciner et de soulager brûlures et inflammations."
    },
    {
      "icon": "🧭",
      "title": "Radiesthésie",
      "text": "Les radiesthésistes du 75 analysent les réseaux telluriques et les champs électromagnétiques de votre habitat. À Paris, ils maîtrisent les spécificités des immeubles haussmanniens, des caves voûtées et des influences du métro souterrain sur les champs énergétiques, harmonisant les habitats urbains les plus complexes."
    },
    {
      "icon": "🌍",
      "title": "Géobiologie",
      "text": "Les géobiologues à Paris (75) analysent les réseaux telluriques (Hartmann, Curry), failles, cours d'eau souterrains et pollutions électromagnétiques de votre habitat. Leur expertise permet de neutraliser les nuisances invisibles et d'optimiser l'énergie de votre lieu de vie."
    },
    {
      "icon": "🧘",
      "title": "Méditation & Pleine Conscience",
      "text": "Les instructeurs de méditation et pleine conscience à Paris proposent des séances individuelles ou en groupe pour cultiver le calme intérieur, réduire le stress et développer la présence à soi. Une pratique millénaire adaptée au rythme contemporain."
    },
    {
      "icon": "🌀",
      "title": "Access Bars",
      "text": "Les praticiens Access Bars à Paris (75) activent 32 points énergétiques sur le crâne pour libérer les schémas mentaux limitants, les blocages émotionnels et les croyances figées. Une technique douce, profondément relaxante et de plus en plus reconnue."
    },
    {
      "icon": "🥣",
      "title": "Sound Healing",
      "text": "Les praticiens en sound healing à Paris utilisent bols tibétains, bols de cristal, gongs et diapasons thérapeutiques pour induire un état de relaxation profonde. Les fréquences vibratoires agissent en douceur sur le corps physique, émotionnel et énergétique."
    },
    {
      "icon": "💆",
      "title": "Massage énergétique",
      "text": "Les praticiens en massage énergétique du 75 allient toucher intuitif et lecture des flux vitaux. En travaillant sur les méridiens, les chakras et les points énergétiques du corps, ils libèrent les tensions physiques, dénouent les blocages profonds et rééquilibrent la circulation subtile pour un profond apaisement corps-esprit."
    },
    {
      "icon": "🕊️",
      "title": "Libération émotionnelle",
      "text": "Les praticiens en libération émotionnelle du 75 accompagnent la traversée des émotions bloquées — colère, peur, tristesse, deuil, traumatismes anciens. Par un travail ciblé sur la mémoire cellulaire et le système nerveux, ils permettent de dénouer les schémas ancrés et de retrouver une paix intérieure durable."
    }
  ],
  "pourquoiConsulter": [
    {
      "h3": "L'énergie des axes sacrés de la capitale",
      "text": "Paris est construite sur un réseau d'axes sacrés historiques (axe historique Louvre-Défense, cardo et decumanus romains) qui concentrent une énergie tellurique particulière. Les praticiens en reiki du 75 travaillent en résonance avec ces lignes de force millénaires, proposant des soins d'une profondeur historique unique."
    },
    {
      "h3": "La nécessité du ressourcement en milieu urbain",
      "text": "La vie parisienne, avec son rythme effréné, sa pollution électromagnétique et son stress permanent, crée un besoin vital de rééquilibrage énergétique. Les séances de magnétisme à Paris sont particulièrement recherchées pour leur capacité à restaurer l'harmonie intérieure au cœur de l'agitation."
    },
    {
      "h3": "La lithothérapie face aux nuisances urbaines",
      "text": "L'environnement parisien, dense en ondes électromagnétiques et en perturbations énergétiques, nécessite des approches spécifiques. Les lithothérapeutes du 75 utilisent des pierres de protection comme la tourmaline noire, l'œil de tigre et le shungite pour créer des bulles énergétiques protectrices dans l'habitat urbain."
    },
    {
      "h3": "Une tradition ésotérique parisienne séculaire",
      "text": "Paris a toujours été un carrefour des savoirs ésotériques et des pratiques de guérison. Des alchimistes du Moyen Âge aux théosophes du XIXe siècle, la capitale a nourri une tradition de guérison énergétique riche et diverse que les praticiens du 75 perpétuent et modernisent."
    }
  ],
  "ouConsulter": [
    {
      "ville": "Paris Centre (1er-4e)",
      "text": "Cœur historique de la capitale, le centre de Paris concentre de nombreux praticiens en pratiques énergétiques. Les cabinets de reiki et magnétisme y proposent des consultations dans un cadre alliant patrimoine exceptionnel et énergie millénaire du Louvre et de Notre-Dame."
    },
    {
      "ville": "Paris Ouest (7e, 8e, 16e)",
      "text": "Quartiers résidentiels prestigieux de la capitale, l'ouest parisien accueille des praticiens haut de gamme spécialisés dans les approches énergétiques sophistiquées. Les séances de lithothérapie et géobiologie y sont particulièrement développées pour les habitats luxueux."
    },
    {
      "ville": "Paris Est (11e, 12e, 20e)",
      "text": "Quartiers dynamiques et créatifs de l'est parisien, ces arrondissements abritent des praticiens en pratiques énergétiques aux approches innovantes et accessibles. L'énergie jeune et cosmopolite de ces quartiers nourrit des méthodes énergétiques contemporaines et inclusives."
    },
    {
      "ville": "Paris Nord (9e, 17e, 18e)",
      "text": "Du Pigalle animé aux hauteurs de Montmartre, le nord parisien offre un panel varié de praticiens énergétiques. La butte Montmartre, avec son énergie tellurique particulière, est un lieu privilégié pour les séances de reiki et de méditation énergétique."
    },
    {
      "ville": "Boulogne-Billancourt",
      "text": "Commune limitrophe de la capitale, Boulogne-Billancourt accueille des praticiens qui desservent les zones résidentielles de l'ouest parisien. Leur approche combine modernité des techniques et sérénité des espaces verts du Bois de Boulogne."
    },
    {
      "ville": "Saint-Denis",
      "text": "Commune de la Plaine Saint-Denis accueillant des praticiens en pratiques énergétiques aux tarifs souvent plus accessibles, desservant les zones périphériques du nord-est parisien avec des approches authentiques et communautaires."
    }
  ],
  "faq": [
    {
      "q": "Quel est le tarif moyen d'une séance de magnétisme à Paris ?",
      "a": "À Paris (75), une séance de magnétisme dure généralement 45 à 60 minutes et coûte entre 60€ et 120€. Dans les arrondissements prestigieux (7e, 8e, 16e), les tarifs des praticiens expérimentés peuvent atteindre 150€. En périphérie et dans les zones plus populaires, les prix sont souvent plus accessibles, autour de 50€ à 80€."
    },
    {
      "q": "Le reiki est-il efficace contre le stress parisien ?",
      "a": "Oui, et c'est l'une des principales raisons de consultation à Paris. Le reiki est particulièrement efficace pour gérer le stress urbain, l'anxiété liée au rythme de vie parisien et l'épuisement professionnel. Les praticiens du 75 développent des protocoles spécifiques adaptés aux sollicitations permanentes de la vie dans la capitale."
    },
    {
      "q": "Quelles pierres recommander pour un appartement parisien ?",
      "a": "Les lithothérapeutes de Paris recommandent la tourmaline noire pour la protection contre les ondes électromagnétiques, le shungite pour la purification de l'eau et de l'air, l'améthyste pour la sérénité et l'œil de tigre pour l'ancrage. Ces pierres sont particulièrement adaptées aux environnements urbains denses et aux habitats collectifs parisiens."
    },
    {
      "q": "La géobiologie est-elle différente dans les immeubles parisiens ?",
      "a": "Oui, absolument. Les géobiologues de Paris analysent des paramètres spécifiques aux habitats urbains : les réseaux telluriques perturbés par les fondations profondes, les champs électromagnétiques des installations collectives, les influences du métro souterrain et les configurations particulières des caves et sous-sols parisiens. Ces facteurs créent des configurations énergétiques uniques à la capitale."
    },
    {
      "q": "Y a-t-il des stages de bien-être énergétique à Paris ?",
      "a": "Oui, Paris est un centre majeur pour les formations et retraites de bien-être énergétique. De nombreux praticiens organisent des stages de reiki, des formations de lithothérapie et des séminaires de géobiologie dans la capitale. L'offre est particulièrement riche et diversifiée, avec des approches allant du traditionnel au très contemporain."
    }
  ],
  "voisins": [
    {
      "code": "77",
      "name": "Seine-et-Marne",
      "slug": "77-seine-et-marne"
    },
    {
      "code": "78",
      "name": "Yvelines",
      "slug": "78-yvelines"
    },
    {
      "code": "91",
      "name": "Essonne",
      "slug": "91-essonne"
    },
    {
      "code": "92",
      "name": "Hauts-de-Seine",
      "slug": "92-hauts-de-seine"
    },
    {
      "code": "93",
      "name": "Seine-Saint-Denis",
      "slug": "93-seine-saint-denis"
    },
    {
      "code": "94",
      "name": "Val-de-Marne",
      "slug": "94-val-de-marne"
    },
    {
      "code": "95",
      "name": "Val-d'Oise",
      "slug": "95-val-d-oise"
    }
  ],
  "conclusion": "<strong>Paris (75)</strong> est un département d'énergie intense et de diversité remarquable, où les pratiques énergétiques s'adaptent aux besoins spécifiques de la vie urbaine. Que vous résidiez dans le cœur historique, les quartiers résidentiels ou les zones périphériques de la capitale, vous trouverez des praticiens énergétiques en parfaite harmonie avec ce territoire métropolitain d'exception. Consultez notre annuaire pour découvrir les magnétiseurs, praticiens en reiki, lithothérapeutes et géobiologues de Paris. Chaque séance est une invitation à retrouver l'équilibre et la sérénité au cœur de l'agitation parisienne, et à vous reconnecter à l'essentiel."
};

export default data;
